import * as React from "react"

import { MetricSelect } from "@components";


export default function PriceEvolutionTableMinMaxActions({ tableMetric, handleChangeMetric }) {
	return <MetricSelect
        fullWidth={false}
        sx={{ minWidth: 200 }}
        value={tableMetric}
        onChange={e => handleChangeMetric(e.target.value)}
	/>
}